/**
 * Sesión del operador. En sessionStorage (no localStorage): se cierra con la
 * pestaña, por ser la consola que ve todas las empresas.
 */

import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface SessionState {
  token: string | null;
  /** El token solo sirve para configurar 2FA (obligatorio). */
  requires2faSetup: boolean;
  set: (token: string, requires2faSetup: boolean) => void;
  clear: () => void;
}

export const useSession = create<SessionState>()(
  persist(
    (set) => ({
      token: null,
      requires2faSetup: false,
      set: (token, requires2faSetup) => set({ token, requires2faSetup }),
      clear: () => set({ token: null, requires2faSetup: false }),
    }),
    {
      name: "sistema-sale-platform.session",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
